import React, { useMemo } from "react";
import CustomSelect from "../../DesignSystem/Dropdowns/CustomSelect";

const PortalAccessSelectField = ({
  label,
  value = "",
  onChange,
  options = [],
  placeholder = "Select option",
  disabled = false,
  clearable = false,
  searchable = true,
  searchPlaceholder = "Type to filter...",
}) => {
  const customSelectOptions = useMemo(() => {
    return options
      .map((option) => ({
        id: option.value ?? option.id ?? "",
        name: option.label ?? option.name ?? "",
      }))
      .filter((option) => option.id || option.name);
  }, [options]);

  return (
    <div className="portal-access-select-field">
      {label && <span className="portal-access-select-label">{label}</span>}

      <CustomSelect
        options={customSelectOptions}
        value={value || ""}
        disabled={disabled}
        placeholder={placeholder}
        clearable={clearable}
        searchable={searchable}
        searchPlaceholder={searchPlaceholder}
        onChange={(event) => onChange(event.target.value)}
      />
    </div>
  );
};

export default PortalAccessSelectField;
